import * as Immutable from "immutable";
import { ImmutableObject } from "../../../../shared/immutableObject";
import { PaginationInfo, SortingInfo, ConfSearchResultItem } from "../../models/responses";
import { ConfigurationSearch } from "../../models";
import { QuerySourceTypes } from "../../models/responses/searchResult";

export class SearchSessionData extends ImmutableObject {

  public readonly SEARCH_SESSION_ID = "searchSessionId";
  public readonly CONF_SEARCH_RESULT_ITEMS = "confSearchResultItems";
  public readonly PAGINATION_INFO = "paginationInfo";
  public readonly SORTING_INFO = "sortingInfo";  
  public readonly QUERY = "query";
  public readonly QUERY_SOURCE_TYPE = "querySourceType";

  get searchSessionId(): number { return this.getInternalValue<number>(this.SEARCH_SESSION_ID); }
  setSearchSessionId(searchSessionId: number): this { return this.setInternalValue(this.SEARCH_SESSION_ID, searchSessionId); }

  get confSearchResultItems(): Immutable.List<ConfSearchResultItem> { return this.getInternalValue<Immutable.List<ConfSearchResultItem>>(this.CONF_SEARCH_RESULT_ITEMS); }
  setConfSearchResultItems(confSearchResultItems: Immutable.List<ConfSearchResultItem>): this { return this.setInternalValue(this.CONF_SEARCH_RESULT_ITEMS, confSearchResultItems); }

  get paginationInfo(): PaginationInfo { return this.getInternalValue<PaginationInfo>(this.PAGINATION_INFO); }
  setPaginationInfo(paginationInfo: PaginationInfo): this { return this.setInternalValue(this.PAGINATION_INFO, paginationInfo); }

  get sortingInfo(): SortingInfo { return this.getInternalValue<SortingInfo>(this.SORTING_INFO); }
  setSortingInfo(sortingInfo: SortingInfo): this { return this.setInternalValue(this.SORTING_INFO, sortingInfo); }

  get query(): ConfigurationSearch { return this.getInternalValue<ConfigurationSearch>(this.QUERY); }
  setQuery(query: ConfigurationSearch): this { return this.setInternalValue(this.QUERY, query); }

  get querySourceType(): QuerySourceTypes { return this.getInternalValue<QuerySourceTypes>(this.QUERY_SOURCE_TYPE); }
  setQuerySourceType(querySourceType: QuerySourceTypes): this { return this.setInternalValue(this.QUERY_SOURCE_TYPE, querySourceType); }
}